import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-address-listing',
  templateUrl: './customer-address-listing.component.html',
  styleUrls: ['./customer-address-listing.component.css']
})
export class CustomerAddressListingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/customer-address-listing/customer-address-listing.component.ts